// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Caml_option from "rescript/lib/es6/caml_option.js";

var titles = [];

function addTitle(title) {
  titles.unshift(title);
}

function changeTitle(currentTitle, newTitle) {
  var pos = titles.indexOf(currentTitle);
  titles[pos] = newTitle;
}

function removeTitle(title) {
  var pos = titles.indexOf(title);
  titles.splice(pos, 1);
}

function emitChange() {
  if (titles.length <= 0) {
    return ;
  }
  var title = titles[0];
  if (title !== document.title) {
    document.title = title;
    return ;
  }
  
}

function DocumentTitle(props) {
  var title = props.title;
  var ref = React.useRef(title);
  React.useEffect((function () {
          titles.unshift(ref.current);
          emitChange();
          return (function () {
                    removeTitle(ref.current);
                    emitChange();
                  });
        }), []);
  React.useEffect((function () {
          changeTitle(ref.current, title);
          ref.current = title;
          emitChange();
        }), [title]);
  return React.createElement(React.Fragment, {
              children: Caml_option.some(props.children)
            });
}

var make = DocumentTitle;

export {
  titles ,
  addTitle ,
  changeTitle ,
  removeTitle ,
  emitChange ,
  make ,
}
/* react Not a pure module */
